// src/services/certificateApi.js

import api from "./api";

export const runCertificate = (certType) =>
  api.post(`/admin/certificates/run/${certType}`);

export const getCertificateViewUrl = (filename) =>
  `/api/admin/certificates/view/${encodeURIComponent(filename)}`;

export const getCertificateDownloadUrl = (filename) =>
  `/api/admin/certificates/download/${encodeURIComponent(filename)}`;

export const certifyNF525 = () =>
  api.post("/async/fec").then((r) => r.data);